define('responsive-gameday/views/render/BoxscoreViewRender',['require','exports','module','./ViewRender','disk-storage/disk-storage','jquery','Wax/get!view-templates/boxscore/boxscore','Wax/get!view-templates/linescore/embeddedLinescore','Wax/get!view-templates/boxscore/batter','Wax/get!view-templates/boxscore/bench','Wax/get!view-templates/boxscore/pitcher','Wax/get!view-templates/boxscore/bullpen'],function(require,exports,module){
    var ViewRender = require('./ViewRender'),
        diskStorage = require("disk-storage/disk-storage"),
        $ = require( "jquery" ),
        Superclass;

    function BoxscoreViewRender(){
        Superclass.constructor.call(this,
            require('Wax/get!view-templates/boxscore/boxscore'),{
                embeddedLinescoreView   : require( 'Wax/get!view-templates/linescore/embeddedLinescore' ),
                batterView              : require( 'Wax/get!view-templates/boxscore/batter' ),
                benchView               : require( 'Wax/get!view-templates/boxscore/bench' ),
                pitcherView             : require( 'Wax/get!view-templates/boxscore/pitcher' ),
                bullpenView             : require( 'Wax/get!view-templates/boxscore/bullpen' )
            }
        );
    }
    ViewRender.spawn(BoxscoreViewRender).define({
        handleAvgOps : function(toggle){
            var column=$(toggle),
                hideavgops = column.data('view-state'),
                boxscoreTables = $('.avgops-table'), // Change both team's stat preference
                showavgops = column.siblings('.avgops').data('view-state');
            if(showavgops){
                boxscoreTables.removeClass(hideavgops);
                boxscoreTables.addClass(showavgops);
                diskStorage.put('gameday', 'boxscore.selectedavgops', showavgops);
                this.viewState.avgops = showavgops;
            }
        }
    });

    Superclass=BoxscoreViewRender.superclass;

    return BoxscoreViewRender;
});
